import * as React from 'react';
import { IUrgencyLabel } from '../../../interfaces/ISearchApi';
import * as Colors from '../../../consts/variables';

interface IProps {
    label: IUrgencyLabel;
    isNewDesign?: boolean;
}

const wrapper: any = {
    color: Colors.white,
    padding: '2px 5px',
    fontSize: 12,
    height: 17,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
};

const newWrapper: any = {
    display: 'relative',
    marginBottom: '3px',
    width: '162px',
    height: '20px',
    textAlign: 'center',
    color: Colors.white,
    marginTop: 'auto',
    fontWeight: 700,
    fontSize: '11px',
    lineHeight: '20px',
    justifySelf: 'right',
};

const color = {
    Stock: Colors.lightRed,
    BestSeller: Colors.lightOrange,
    Views: Colors.blue,
    'Top Reviewed': Colors.lightGreen,
    'High Demand': Colors.darkBlue,
    OnBoardCredit: Colors.lightGreen,
};

const newColor = {
    Stock: Colors.paprika,
    BestSeller: Colors.lightOrange,
    Views: Colors.labels.highDemand,
    'Top Reviewed': Colors.lightGreen,
    'High Demand': Colors.labels.highDemand,
    OnBoardCredit: Colors.lightGreen,
};

export const UrgencyLabel = ({ label, isNewDesign }: IProps) => {
    const style = isNewDesign
        ? { ...newWrapper, backgroundColor: newColor[label.type] }
        : { ...wrapper, backgroundColor: color[label.type] };

    return <span style={style}>{label.value}</span>;
};
